export const useFilterWorksheetsStore = defineStore('FilterWorksheetsStore', () => {
  const { getWorksheetsAssociatedToFitters } = useWorksheetAPI();

  const worksheets = ref<WorksheetFilterResponseDTO[]>([]);

  async function fetchWorksheetsAssociatedToFitters(fitterIds: number[]) {
    const response: ResponseDTO<WorksheetFilterResponseDTO[]> | undefined = await getWorksheetsAssociatedToFitters(fitterIds);

    if (response?.HasErrors === false) {
      worksheets.value = response.Data;
    }
  }

  function $reset() {
    worksheets.value = [];
  }

  return {
    _worksheets: worksheets,
    worksheets: readonly(worksheets),
    fetchWorksheetsAssociatedToFitters,
    $reset
  };
});
